// GraphQL queries for chat
import {
  CHAT_ROOM_FIELDS_FRAGMENT,
  MESSAGE_WITH_SENDER_FRAGMENT
} from '../fragments/chat';
import { PAGINATION_FRAGMENT } from '../fragments/common';

// Get chat rooms list
export const GET_CHAT_ROOMS_QUERY = `
  query ChatRooms($page: Int, $limit: Int, $where: ChatRoom_where) {
    ChatRooms(page: $page, limit: $limit, where: $where) {
      docs {
        ${CHAT_ROOM_FIELDS_FRAGMENT}
      }
      totalDocs
      limit
      page
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

// Get single chat room by ID
export const GET_CHAT_ROOM_QUERY = `
  query ChatRoom($roomId: String!) {
    ChatRoom(id: $roomId) {
      ${CHAT_ROOM_FIELDS_FRAGMENT}
    }
  }
`;

// Get messages for a chat room
export const GET_CHAT_MESSAGES_QUERY = `
  query GetChatMessages($chatRoomId: String!, $page: Int, $limit: Int) {
    getChatMessages(chatRoomId: $chatRoomId, page: $page, limit: $limit) {
      docs {
        ${MESSAGE_WITH_SENDER_FRAGMENT}
      }
      totalDocs
      limit
      page
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;